import { ModalType, useModalContext } from '../context';
import { useEditSavedRowDesignContext } from '../context/EditSavedRowDesignContext';

/**
 * Returns handler for requesting to close the saved row design editor.
 */
export const useOnRequestCloseSavedRowDesign = () => {
  const { openModal, closeModal } = useModalContext();
  const { hasUnsavedSavedRowDesignChanges, onExitSavedRowDesignEditor } =
    useEditSavedRowDesignContext();

  const onRequestCloseSavedRowDesignEditor = () => {
    if (hasUnsavedSavedRowDesignChanges) {
      openModal(ModalType.SavedRowUnsavedChangesModal, {
        onClose: () => {
          closeModal(ModalType.SavedRowUnsavedChangesModal);
        },
        onLeaveWithoutSaving: () => {
          onExitSavedRowDesignEditor();
          closeModal(ModalType.SavedRowUnsavedChangesModal);
        },
      });
    } else {
      onExitSavedRowDesignEditor();
    }
  };

  return onRequestCloseSavedRowDesignEditor;
};
